import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=b68ff8dc&scoped=true&lang=html"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=b68ff8dc&prod&lang=css"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=b68ff8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68ff8dc",
  null
  
)

export default component.exports